import { render, staticRenderFns } from "./loadingComponents.vue?vue&type=template&id=7c874958&scoped=true&"
import script from "./loadingComponents.vue?vue&type=script&lang=js&"
export * from "./loadingComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c874958",
  null
  
)

export default component.exports